import styles from "./chart.module.css"

import React from "react"
import cx from "classnames"
import * as util from "activities/util"
import * as fonts from "shared/fonts"
import {get} from "lodash"

export const getYAxisRange = (dataMax) => (dataMax > 12000 ? Math.ceil(dataMax / 2000) * 2000 : Math.ceil(dataMax / 200) * 200)

// accepts the key for the x-axis value, and the array of data for recharts
export const getXAxisTicks = (val, data) => data.map((item) => item[val]).filter((val) => val % 5 === 0)

export const tickStyles = {
  fontSize: "12",
  fontFamily: fonts.getFontFamily(),
  fill: "#5C5761",
  dy: 8
}

export const formatTooltipValueVersion2 = (year, key) => (year ? util.formatDollars(util.ifNegative(year[key])) : util.formatDollars(0))

export const formatTooltipValue = (value, type) => (type === "currency" ? util.formatDollarsNoCents(value) : type === "number" ? value : "")

const TooltipProperty = ({data, property, index, theme}) => {
  const tooltip = data.fields[property.id].tooltip
  return (
    <div className={cx(styles["tooltip"], fonts.getFontClass())}>
      <span className={styles["with-indicator"]}>
        {tooltip.color && <div style={{background: "#" + theme[tooltip.color]}} className={styles["indicator"]} />}
        {tooltip.title}:
      </span>
      <span className={styles["value"]}>{formatTooltipValue(property.value, property.type)}</span>
    </div>
  )
}

const tooltipHeights = {
  2: 42,
  3: 66,
  4: 90
}

export const tooltipStyles = (rows) => ({
  background: "white",
  borderRadius: 4,
  boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.30), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)",
  padding: 12,
  width: 180,
  height: tooltipHeights[rows] || tooltipHeights[3],
  textAlign: "left",
  boxSizing: "content-box",
  lineHeight: 1
})

export const CustomTooltip = ({payload, data, theme}) => {
  if (payload && payload.length > 0) {
    const properties = Object.keys(data.fields)
      .filter((key) => typeof data.fields[key].tooltip === "object")
      .sort((a, b) => data.fields[a].tooltip.order - data.fields[b].tooltip.order)
      .map((key) => ({
        id: key,
        value: payload[0].payload[key],
        type: data.fields[key].type
      }))
    return (
      <div>
        {properties.map((p, i) => (
          <TooltipProperty key={p.id} data={data} property={p} index={i} theme={theme} />
        ))}
      </div>
    )
  } else {
    return null
  }
}

export const AxisLabel = ({axis, label}) => <div className={cx(styles[axis], fonts.getFontClass())}>{label}</div>
